import { render, staticRenderFns } from "./BookGenerator.vue?vue&type=template&id=16aa4d04&scoped=true&"
import script from "./BookGenerator.vue?vue&type=script&lang=js&"
export * from "./BookGenerator.vue?vue&type=script&lang=js&"
import style0 from "./BookGenerator.vue?vue&type=style&index=0&id=16aa4d04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16aa4d04",
  null
  
)

export default component.exports